import { render, staticRenderFns } from "./admin_user_detail.vue?vue&type=template&id=fd458376&scoped=true&"
import script from "./admin_user_detail.vue?vue&type=script&lang=ts&"
export * from "./admin_user_detail.vue?vue&type=script&lang=ts&"
import style0 from "./admin_user_detail.vue?vue&type=style&index=0&id=fd458376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd458376",
  null
  
)

export default component.exports